var YOUR_API_KEY = "AIzaSyA8C07mG3KalTZzGGcvOVga5BV4PSNNalI";
var TEXT_TRANSLATE_BTN = "Translate";
var TEXT_ORIGINAL_BTN = "Original";

(function($){
  function getTargetLanguage() {
    var browserLanguage = (navigator.language || navigator.userLanguage);
    if (browserLanguage.indexOf('en') > -1){
      return 'en';
    }
    return browserLanguage;
  }

  function translate(text, cb) {

    $.post(
      'https://translation.googleapis.com/language/translate/v2',
      {
        q: text.replace(/(?:\r\n|\r|\n)/g, '<br>'),
        target: getTargetLanguage(),
        key: YOUR_API_KEY
      }, function(resp) {
        cb(resp.data.translations[0].translatedText)
      })
  }


  function injectButton(){
    var footer = $('div.stamped-review-footer');

    footer.before('<p href="javascript:void(0)" class="stamped-review-content-body-translate">'+TEXT_TRANSLATE_BTN+'</p>');


    $('.stamped-review-content-body-translate').click(function(){
      var original = $(this).siblings('.stamped-review-content-body');
      var header = $(this).siblings('.stamped-review-header-title');
      var btn = $(this);

      if(original.data('original-text')){ //In Tranlsated
        original.text(original.data('original-text'));
        original.data('original-text', null);
        if(header.length > 0){
          header.text(header.data('original-text'));
          header.data('original-text', null);
        }
        btn.text(TEXT_TRANSLATE_BTN);
      }else{ //In Original
        translate(original.text(), function(translated){
          original.data('original-text', original.text());
          original.html(translated);
        });
        if(header.length > 0){
          translate(header.text(), function(translated){
            header.data('original-text', header.text());
            header.text(translated);
          });
        }
        btn.text(TEXT_ORIGINAL_BTN);
      }


    })

  }

  function addEventListenerStamped(el, eventName, handler) {
   if (el.addEventListener) { el.addEventListener(eventName, handler); }
     else { el.attachEvent('on' + eventName, function () { handler.call(el); }); }
  }

  addEventListenerStamped(document, 'stamped:reviews:loaded', function(e) {
    injectButton();
  });

//    var timer =  setInterval(function(){
//     if($(".stamped-reviews").length > 0){
//       injectButton();
//       clearInterval(timer);
//     }
//   }, 500);


})(jQuery)